// extracted by mini-css-extract-plugin
module.exports = {"outerClass":"NetWorth_outerClass__1Hatu","header":"NetWorth_header__36HkZ","headTag":"NetWorth_headTag__6bR4Z","amtTag":"NetWorth_amtTag__3-pRW","center":"NetWorth_center__3KHlL"};